import { render, staticRenderFns } from "./apagingsubmodul.vue?vue&type=template&id=334cab63&scoped=true"
import script from "./apagingsubmodul.vue?vue&type=script&lang=js"
export * from "./apagingsubmodul.vue?vue&type=script&lang=js"
import style0 from "./apagingsubmodul.vue?vue&type=style&index=0&id=334cab63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334cab63",
  null
  
)

export default component.exports